import { render, staticRenderFns } from "./DeleteRegionModal.vue?vue&type=template&id=531003d7&"
import script from "./DeleteRegionModal.vue?vue&type=script&lang=js&"
export * from "./DeleteRegionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports